import {
  DEFAULT_MESSENGER_LABEL,
  DEFAULT_SMS_LABEL,
  DEFAULT_WA_LABEL,
} from './constants';
import type { LebelConfigList } from './types';

export const lebelConfigList: LebelConfigList = {
  whatsApp: DEFAULT_WA_LABEL,
  messenger: DEFAULT_MESSENGER_LABEL,
  sms: DEFAULT_SMS_LABEL,
};
